// Messages that can be sent to the server
export enum CheckInRequestType {
	// Subscribe to events for a check-in session
	SubscribeToCheckIn,
}
